export default __webpack_public_path__ + "static/media/amex.ce520835.svg";